import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from '@mui/material'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import i18n from '../../i18n/locales/en'

import styles from './GlossaryTooltip.module.scss'

const glossaryReverseMapping = () => {
  const terms = i18n.glossary.terms
  const reverseMapping = {}

  Object.entries(terms).forEach(([termID, termData]) => {
    const termName = termData.title
    reverseMapping[termName] = termID
  })
  return reverseMapping
}

export const getTermID = (termName) => {
  const reverseMapping = glossaryReverseMapping()
  const termID = reverseMapping[termName]

  if (!termID) {
    console.warn(`Term ID not found for term: ${termName}`)
    return null
  }

  return termID
}

const GlossaryTooltip = ({ termId, children, placement = 'top' }) => {
  const { t } = useTranslation()
  const definition = t(`glossary.terms.${termId}.description`)

  if (!i18n.glossary.terms[termId]) {
    return <>{children}</>
  }

  return (
    <Tooltip
      title={
        <span className={styles.definitionText}>{definition}</span>
      }
      arrow
      placement={placement}
    >
      <span className={styles.tooltipTrigger}>
        <Link
          to={`/glossary#term-${termId}`}
          className={styles.glossaryLink}
        >
          {children}
        </Link>
      </span>
    </Tooltip>
  )
}

GlossaryTooltip.propTypes = {
  termId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  placement: PropTypes.string,
}

export default GlossaryTooltip
